var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79.00396mm",
    height: "52.011475mm",
    viewBox: "0 0 79.00396 52.011475",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-65.498026,-122.49427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "translate(0,79.168139)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1a1a1a",
      strokeWidth: 0.167831
    },
    id: "rect1",
    width: 79.003952,
    height: 11.946217,
    x: 65.498024,
    y: 43.326126
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1a1a1a",
      strokeWidth: 0.167831
    },
    id: "rect1-0",
    width: 79.003952,
    height: 11.946217,
    x: 65.498024,
    y: 63.358753
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1a1a1a",
      strokeWidth: 0.167831
    },
    id: "rect1-9",
    width: 79.003952,
    height: 11.946217,
    x: 65.498024,
    y: 83.39138
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.598902e743e24c1563fa5ba926b56d2f.svg";
export { ForwardRef as ReactComponent };